"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var tslib_1 = require("tslib");
var ui_blocks_1 = require("@hopin-team/ui-blocks");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");
var ui_symbols_1 = require("@hopin-team/ui-symbols");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var icon_1 = require("./icon");
var field = ui_blocks_1.FORM.field, inverseField = ui_blocks_1.FORM.inverseField, hasErrors = ui_blocks_1.FORM.hasErrors, inverseErrorStyles = ui_blocks_1.FORM.inverseErrorStyles;
var caption = ui_blocks_1.TYPOGRAPHY.caption;
// Sizes =======================================================================
var Sizes;
(function (Sizes) {
    Sizes[Sizes["small"] = 4] = "small";
    Sizes[Sizes["medium"] = 5] = "medium";
})(Sizes || (Sizes = {}));
var makeSizeStyles = function (size, theme) {
    var _a;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), (0, ui_symbols_1.calcSpace)(Sizes[size], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP));
};
var makePaddingRightStyles = function (actionsWidth) { return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding-right: ", "rem;\n"], ["\n  padding-right: ", "rem;\n"])), actionsWidth); };
var multiLineStyles = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  resize: vertical;\n  overflow: auto;\n  min-height: ", ";\n  padding-bottom: ", ";\n  padding-top: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n"], ["\n  resize: vertical;\n  overflow: auto;\n  min-height: ", ";\n  padding-bottom: ", ";\n  padding-top: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(7, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(1.5, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(1.5, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(2.5, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(2, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
});
var hasIconStyles = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  padding-left: ", ";\n"], ["\n  padding-left: ", ";\n"])), (0, ui_symbols_1.calcSpace)(6));
var hasErrorsStyles = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), hasErrors);
var inverseErrorsStyles = (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), inverseErrorStyles);
var isInverseStyles = (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), inverseField);
var captionTypography = (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  ::placeholder {\n    ", "\n  }\n"], ["\n  ", "\n\n  ::placeholder {\n    ", "\n  }\n"])), caption, caption);
exports.Input = styled_components_1.default.input.withConfig({
    shouldForwardProp: function (prop) {
        return ![
            'sizeOption',
            'hasErrors',
            'hasIcon',
            'isInverse',
            'actionsWidth',
        ].includes(prop);
    },
})(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  ", "\n  width: 100%;\n  padding: 0 1rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n  &:focus ~ ", " {\n    color: ", ";\n  }\n\n  &:read-only {\n    border: none;\n    background: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  width: 100%;\n  padding: 0 1rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n  &:focus ~ ", " {\n    color: ", ";\n  }\n\n  &:read-only {\n    border: none;\n    background: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), field, icon_1.Icon, function (_a) {
    var isInverse = _a.isInverse, theme = _a.theme;
    return isInverse
        ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme)
        : (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, function (_a) {
    var isInverse = _a.isInverse, theme = _a.theme;
    return isInverse
        ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["900"]', theme)
        : (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["100"]', theme);
}, function (props) {
    return props.as !== 'textarea'
        ? (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeSizeStyles)
        : multiLineStyles;
}, function (props) {
    return props.actionsWidth &&
        (0, ui_helper_props_to_styles_1.makeStyles)(props, 'actionsWidth', makePaddingRightStyles);
}, function (props) { return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasIcon', hasIconStyles); }, function (props) {
    return props.isInverse
        ? (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasErrors', inverseErrorsStyles)
        : (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasErrors', hasErrorsStyles);
}, function (_a) {
    var isInverse = _a.isInverse;
    return isInverse && isInverseStyles;
}, function (_a) {
    var sizeOption = _a.sizeOption;
    return sizeOption === 'small' && captionTypography;
}, function (_a) {
    var type = _a.type;
    return type === 'search' &&
        "&::-webkit-search-decoration,\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-results-button,\n  &::-webkit-search-results-decoration {\n    display: none;\n  }";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=input.js.map